import { render, staticRenderFns } from "./AddBrokerOrCedent.vue?vue&type=template&id=70f179b2&scoped=true&"
import script from "./AddBrokerOrCedent.vue?vue&type=script&lang=js&"
export * from "./AddBrokerOrCedent.vue?vue&type=script&lang=js&"
import style0 from "./AddBrokerOrCedent.vue?vue&type=style&index=0&id=70f179b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f179b2",
  null
  
)

export default component.exports